export default function Header() {
  return (
    <header className="flex p-12 justify-between items-center bg-cream text-white">
      <div className="flex items-center ml-auto space-x-4">
        <div className="w-10 h-10 flex items-center justify-center bg-gray-700 rounded-full">
          <span className="text-white">AB</span>
        </div>
        <span className="text-lg">User Name</span>
      </div>
    </header>
  );
}
